const associar_estrutura_curricular_a_escola = [
  {
    path: "/associar-estrutura-curricular-a-escola",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      breadCrumb: "Informações Acadêmicas - Manutenção de Histórico",
      requireAuth: false,
    },
    children: [
      {
        path: "/associar-estrutura-curricular-a-escola",
        name: "associar_estrutura_curricular_a_escola",
        component: () =>
          import(
            "@/views/AssociarEstruturaCurricularAEscola/AssociarEstruturaCurricularAEscolaHome.vue"
          ),
      },
      {
        path: "/cadastrar-associar-estrutura-curricular-a-escola",
        name: "cadastrar_associar_estrutura_curricular_a_escola",
        component: () =>
          import(
            "@/views/AssociarEstruturaCurricularAEscola/AssociarEstruturaCurricularAEscolaCad.vue"
          ),
      },
      {
        path: "/editar-associar-estrutura-curricular-a-escola/:id/:option",
        name: "editar_associar_estrutura_curricular_a_escola",
        component: () =>
          import(
            "@/views/AssociarEstruturaCurricularAEscola/AssossiarEstruturaCurricularAEscolaEdit.vue"
          ),
      },
    ],
  },
];

export { associar_estrutura_curricular_a_escola };
